import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RegistroContatoService } from "./api-registroContato.service";
import { RegistroContatoSignature } from "../../models/signature/RegistroContatoSignature";
import { HistoricoContatoSignature } from "../../models/signature/HistoricoContatoSignature";
import { FiltroRegistroContatoSignature } from "../../models/signature/FiltroRegistroContatoSignature";

@Injectable({
  providedIn: 'root'
})

export class RegistroContatoDataService {

  constructor(private api: RegistroContatoService) {
  }

  public GetRegistroContatoCliente(dealId: string): Observable<any> {
    return this.api.GetRegistroContatoCliente(dealId);
  }

  public UpdateRegistroContatoCliente(signature: RegistroContatoSignature): Observable<any> {
    return this.api.UpdateRegistroContatoCliente(signature);
  }

  public InsertHistoricoContato(signature: HistoricoContatoSignature): Observable<any> {
    return this.api.InsertHistoricoContato(signature);
  }

  public UpdateHistoricoContato(signature: HistoricoContatoSignature): Observable<any> {
    return this.api.UpdateHistoricoContato(signature);
  }

  public GetHistoricoContatoCliente(dealId: string): Observable<any> {
    return this.api.GetHistoricoContatoCliente(dealId);
  }

  public UpdateFeedbackContatoCliente(signature: RegistroContatoSignature): Observable<any> {
    return this.api.UpdateFeedbackContatoCliente(signature);
  }

  public UpdateRegistroContatoRetornoCliente(signature: RegistroContatoSignature): Observable<any> {
    return this.api.UpdateRegistroContatoRetornoCliente(signature);
  }

  public GetTodosRegistroContatoCliente(filtro: FiltroRegistroContatoSignature): Observable<any> {
    return this.api.GetTodosRegistroContatoCliente(filtro);
  }

  public GetTodosRegistrosContatoClienteSimplificados(filtro: FiltroRegistroContatoSignature): Observable<any> {
    return this.api.GetTodosRegistrosContatoClienteSimplificados(filtro);
  }
}
